module.exports = __webpack_public_path__ + "img/phone-contact.d84607c4.svg";